class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.syncEls = Array.from(this.querySelectorAll('[data-tab-sync]'));

    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.selectTab(index));
      tab.addEventListener('keydown', this.onKeyDown.bind(this));
    });
  }

  selectTab(index) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });

    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });

    this.syncEls.forEach((el) => {
      el.hidden = Number(el.dataset.tabSync) !== index;
    });
  }

  onKeyDown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let newIndex = null;

    if (event.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    } else {
      return;
    }

    event.preventDefault();
    this.tabs[newIndex].focus();
    this.selectTab(newIndex);
  }
}

customElements.define('collection-tabs', CollectionTabs);
